@if(deleteCurrentUserModal) {
    <app-modal [modalInput]="deleteCurrentUserModal" (modalCloseOutput)="handleModalClose($event)" class="delete-current-user-modal">
        <div class="modal-content flexGrow1">

            <div class="body-content">
                <div class="body-text" [innerHTML]="'table.delete-self-warning.body' | translate"></div>
            </div>

            <div class="actions">
                <app-form-buttons
                    [showCancelButton]="false"
                    submitTextKey="generics.ok"
                    (submitOutput)="ok()"
                ></app-form-buttons>
            </div>
        </div>
    </app-modal>
}
